import { render, staticRenderFns } from "./AnswerAnalysis.vue?vue&type=template&id=15b23fa4&scoped=true"
import script from "./AnswerAnalysis.vue?vue&type=script&lang=js"
export * from "./AnswerAnalysis.vue?vue&type=script&lang=js"
import style0 from "./AnswerAnalysis.vue?vue&type=style&index=0&id=15b23fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b23fa4",
  null
  
)

export default component.exports